var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 45h45V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M43.298 37.838H26.706l-.027-3.04h3.996v-3.54h-4.027l-.019-2.093h4.046v-3.54h-4.077l-.019-2.094h4.096v-3.54h-4.11v-2.093h4.11v-3.54h-4.11v-2.093h4.11v-3.54h-4.11V5.508h16.733v32.33zM43.04 3.842H26.761V0L0 4.136v36.25L26.761 45v-5.692h16.28c1.082 0 1.959-.79 1.959-1.763V5.605c0-.973-.877-1.763-1.96-1.763z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M32.727 11.455h6.546V8.182h-6.546zM32.727 18h6.546v-3.273h-6.546zM32.727 23.727h6.546v-3.272h-6.546zM32.727 28.636h6.546v-3.272h-6.546zM32.727 34.364h6.546V31.09h-6.546z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M6.85 13.74l3.55-.2 2.231 6.044 2.637-6.293 3.55-.2-4.31 8.58 4.31 8.602-3.753-.25-2.535-6.557-2.536 6.307-3.449-.3 4.007-7.597z",
    mask: "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage1);
export default __webpack_public_path__ + "static/media/page-1.6435936ebcb8583d42a5aa3544bf122f.svg";
export { ForwardRef as ReactComponent };